import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Trade as Component } from './trade';

export const Trade = createWidget<unknown, unknown>()(Component);
